import React, { Component } from 'react';
import PopUpModel from '../components/scanpack/pop_up_model';

class PopupAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popUpModelShow: false,
      message: '',
      messageTypeSuccess: false
    };
    this.timeoutId = null;
  }

  alertBox = (alertMessage, messageTypeSuccessParam = false) => {
    this.setState({
      popUpModelShow: true,
      message: alertMessage,
      messageTypeSuccess: messageTypeSuccessParam
    });

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.timeoutId = setTimeout(() => {
      this.closeAlert();
    }, 4000);
  };

  closeAlert = () => {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }

    this.setState({
      popUpModelShow: false,
      message: '',
      messageTypeSuccess: false
    });
  };

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  render() {
    const { children } = this.props;
    const { popUpModelShow, message, messageTypeSuccess } = this.state;

    return (
      <>
        {typeof children === 'function'
          ? children({ alertBox: this.alertBox, closeAlert: this.closeAlert })
          : children
        }
        {popUpModelShow && (
          <PopUpModel
            closeAlert={this.closeAlert}
            message={message}
            messageTypeSuccess={messageTypeSuccess}
          />
        )}
      </>
    );
  }
}

export default PopupAlert;